import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";
import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	doNotCountKidsAsStock: ForNodeType<boolean>;
	onSetDoNotCountKidsAsStock: (value: boolean) => void;
};

export const QuestionPlanDoNotCountKidsAsStock = ({ doNotCountKidsAsStock, onSetDoNotCountKidsAsStock }: Props) => {
	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={"子供の人数を在庫としてカウントしない設定"}
			isEdited={doNotCountKidsAsStock.isEdited}
			hasError={doNotCountKidsAsStock.error !== undefined}
			inputChildren={
				<CheckboxField
					value={doNotCountKidsAsStock.value}
					label={"子どもの人数を在庫としてカウントしない"}
					handleChange={onSetDoNotCountKidsAsStock}
					errorMessage={doNotCountKidsAsStock.error}
				/>
			}
		/>
	);
};

QuestionPlanDoNotCountKidsAsStock.displayName = "QuestionPlanDoNotCountKidsAsStock";
